import {
  GET_CASE_PAPER_DATA_REQUEST,
  GET_CASE_PAPER_DATA_SUCCESS,
  GET_CASE_PAPER_DATA_FAILURE,
  CLEAR_CASE_PAPER_DATA,
} from "./CasePaperTypes";
import { getFormattedCasePaperData } from "../../services/CasePaperService";

/**
 * Get complete case paper data for a patient
 * @param {string} patientId - Patient ID
 * @returns {Function} Redux thunk action
 */
export const getCasePaperDataAction = (patientId) => {
  return async (dispatch) => {
    try {
      // Dispatch request action
      dispatch({
        type: GET_CASE_PAPER_DATA_REQUEST,
        payload: { patientId },
      });

      // Fetch formatted case paper data
      const formattedData = await getFormattedCasePaperData(patientId);

      // Dispatch success action with formatted data
      dispatch({
        type: GET_CASE_PAPER_DATA_SUCCESS,
        payload: {
          patientId,
          data: formattedData,
        },
      });

      return formattedData;
    } catch (error) {
      console.error("Error in getCasePaperDataAction:", error);

      // Dispatch failure action
      dispatch({
        type: GET_CASE_PAPER_DATA_FAILURE,
        payload: {
          patientId,
          error: error.message || "Failed to fetch case paper data",
        },
      });

      throw error;
    }
  };
};

/**
 * Clear case paper data from store
 * @returns {Object} Redux action
 */
export const clearCasePaperDataAction = () => {
  return {
    type: CLEAR_CASE_PAPER_DATA,
  };
};
